import { handleActions } from 'redux-actions-helpers'
import * as actions from './actions'
import { InitialState } from './types'

const initialState: InitialState = {
  page: null,
  isFetching: false,
  isProcessUserState: false,
  isProcessJoinCourse: false,
  isProcessJoinModule: false,
  isProcessRepayCourse: false,
  isCourseJoined: false,
  error: '',
}

export default handleActions(
  {
    [actions.fetchCoursePage]: state => {
      return {
        ...state,
        page: initialState.page,
        isFetching: true,
        error: initialState.error,
      }
    },
    [actions.fetchCoursePageSuccess]: (state, action) => {
      return {
        ...state,
        page: action.result,
        isFetching: false,
      }
    },
    [actions.fetchCoursePageFailure]: (state, action) => {
      return {
        ...state,
        error: action.error,
        isFetching: false,
      }
    },
    [actions.fetchCourseUserState]: state => {
      return {
        ...state,
        isProcessUserState: true,
      }
    },
    [actions.fetchCourseUserStateSuccess]: (state, action) => {
      return {
        ...state,
        progress: action.result,
        isProcessUserState: false,
      }
    },
    [actions.fetchCourseUserStateFailure]: (state, action) => {
      return {
        ...state,
        error: action.error,
        isProcessUserState: false,
      }
    },
    [actions.joinCourse]: state => {
      return {
        ...state,
        isProcessJoinCourse: true,
      }
    },
    [actions.joinCourseSuccess]: state => {
      return {
        ...state,
        isProcessJoinCourse: false,
        isCourseJoined: true,
      }
    },
    [actions.joinCourseFailure]: (state, action) => {
      return {
        ...state,
        error: action.error,
        isProcessJoinCourse: false,
      }
    },
    [actions.joinModule]: state => {
      return {
        ...state,
        isProcessJoinModule: true,
      }
    },
    [actions.joinModuleSuccess]: state => {
      return {
        ...state,
        isProcessJoinModule: false,
      }
    },
    [actions.joinModuleFailure]: (state, action) => {
      return {
        ...state,
        isProcessJoinModule: false,
        error: action.error,
      }
    },
    [actions.repayCourse]: state => {
      return {
        ...state,
        isProcessRepayCourse: true,
      }
    },
    [actions.repayCourseSuccess]: state => {
      return {
        ...state,
        isProcessRepayCourse: false,
      }
    },
    [actions.repayCourseFailure]: (state, action) => {
      return {
        ...state,
        isProcessRepayCourse: false,
        error: action.error,
      }
    },
    [actions.destroy]: () => initialState,
  },
  { initialState }
)
